<template>
  <div id="sidebarCollapse" class="sidebar-collapse">
    <div class="sidebar-collapse-card">
      <SubTree
        v-show="terenyShow"
        listType="tereny"
        :loading="terenyLoading"
        :name="$t('nav.greenfield')"
        v-slot="slotProps"
        :gminaFilter="gminaShowTereny"
        :gminaBadge="gmina => terenyGminy(gmina).length"
        :red="true"
      >
        <template v-for="(investArea, investAreaIndex) in terenyGminy(slotProps.gmina)">
          <ul :key="investAreaIndex">
            <li
              :key="investAreaIndex"
              @click="
                  $root.$emit('cartogramSelectOferta', {
                    id: investArea.id,
                    woj: investArea.properties.wojewodztwo_nazwa,
                    gmina: investArea.properties.gmina_nazwa,
                    powiat: investArea.properties.powiat_nazwa,
                    oferta: investArea.properties.nazwa.pl
                  })
                "
            >
              <div>{{ investArea.properties.nazwa | showInLang(currlang) }}</div>
              <b-badge>{{ investArea.properties.powierzch | roundTo2Places }} {{ $t("nav.infoPanel.hectare") }}</b-badge>
            </li>
          </ul>
        </template>
      </SubTree>

      <div class="sidebar-collapse-card-item" v-show="haleShow">
        <b-btn
          @click="haleToggle"
          class="sidebar-collapse-btn"
          :class="{
            collapsed: haleExpanded
          }"
          aria-controls="collapse2"
          :aria-expanded="haleExpanded ? 'true' : 'false'"
        >
          <i class="fas fa-map-marker-alt"></i>
          {{ $t("nav.brownfield") }}
          <i v-if="haleLoading" class="fas fa-spinner fa-spin"></i>
          <span class="sidebar-collapse-btn--toggle-text"></span>
        </b-btn>
        <template v-for="(item, mainIndex) in hale">
          <b-collapse :id="`collapse2-${mainIndex}`" :key="mainIndex" :visible="haleExpanded">
            <b-card class="sidebar-collapse-body">
              <div class="sidebar-collapse-sub">
                <b-btn
                  class="sidebar-collapse-sub-btn"
                  variant="link"
                  @click="$store.dispatch('showDetails', { listType: 'hale', item });"
                >
                  {{ item.properties.nazwa | showInLang(currlang) | capitalize }}
                  <b-badge>
                    {{ item.properties.pow_m2 | parseToIntM2 }}
                    <sup>2</sup>
                  </b-badge>
                </b-btn>
              </div>
            </b-card>
          </b-collapse>
        </template>
      </div>

      <!-- <div class="sidebar-collapse-card-item" v-show="biuraShow">
        <b-btn
          @click="biuraToggle"
          class="sidebar-collapse-btn"
          :class="{
            collapsed: biuraExpanded
          }"
          aria-controls="collapse3"
          :aria-expanded="biuraExpanded ? 'true' : 'false'"
        >
          <i class="fas fa-map-marker-alt"></i>
          {{ $t("nav.office") }}
          <i v-if="biuraLoading" class="fas fa-spinner fa-spin"></i>
          <span class="sidebar-collapse-btn--toggle-text"></span>
        </b-btn>
        <template v-for="(item, mainIndex) in biura">
          <b-collapse id="collapse3" :key="mainIndex" :visible="biuraExpanded">
            <b-card class="sidebar-collapse-body">
              <div class="sidebar-collapse-sub">
                <b-btn
                  class="sidebar-collapse-sub-btn"
                  variant="link"
                  @click="$store.dispatch('showDetails', { listType: 'biura', item });"
                >
                  {{ item.properties.nazwa | showInLang(currlang) | capitalize }}
                  <b-badge>
                    {{ item.properties.pow_m2 | parseToIntM2 }}
                    <sup>2</sup>
                  </b-badge>
                </b-btn>
              </div>
            </b-card>
          </b-collapse>
        </template>
      </div> -->

      <SubTree
        v-show="inwestorzyShow"
        listType="inwestorzy"
        :loading="inwestorzyLoading"
        :name="$t('nav.investedAreas')"
        v-slot="slotProps"
        :gminaFilter="gminaShowInwestorzy"
        :gminaBadge="gmina => inwestorzyGminy(gmina).length"
      >
        <template v-for="(investArea, investAreaIndex) in inwestorzyGminy(slotProps.gmina)">
          <ul :key="investAreaIndex">
            <li
              :key="investAreaIndex"
              @click="
                $root.$emit('cartogramSelectOfertaS', {
                  id: investArea.id,
                  woj: investArea.properties.wojewodztwo_nazwa,
                  gmina: investArea.properties.gmina_nazwa,
                  powiat: investArea.properties.powiat_nazwa,
                  oferta: investArea.properties.nazwa.pl
                })
              "
            >
              <div>{{ investArea.properties.nazwa | showInLang(currlang) }}</div>
              <b-badge>{{ investArea.properties.powierzch | roundTo2Places }} {{ $t("nav.infoPanel.hectare") }}</b-badge>
            </li>
          </ul>
        </template>
      </SubTree>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import SubTree from "./SubTree";

export default {
  components: {
    SubTree
  },
  data() {
    return {};
  },
  computed: {
    jstLoading() {
      return this.$store.state.jst.status === "loading";
    },
    terenyLoading() {
      return this.jstLoading || this.$store.state.tereny.status === "loading";
    },
    haleLoading() {
      return this.$store.state.hale.status === "loading";
    },
    biuraLoading() {
      return this.$store.state.biura.status === "loading";
    },
    inwestorzyLoading() {
      return this.jstLoading || this.$store.state.tereny.status === "loading";
    },

    haleExpanded() {
      return this.$store.getters.listExpanded("hale");
    },
    biuraExpanded() {
      return this.$store.getters.listExpanded("biura");
    },
    inwestorzyExpanded() {
      return this.$store.getters.listExpanded("inwestorzy");
    },

    terenyShow() {
      return this.$store.getters["search/terenyShow"];
    },
    haleShow() {
      return this.$store.getters["search/haleShow"];
    },
    biuraShow() {
      return this.$store.getters["search/biuraShow"];
    },
    inwestorzyShow() {
      return this.$store.getters["search/inwestorzyShow"];
    },

    currlang() {
      return this.$parent.currlang;
    },
    hale() {
      return this.$store.getters["search/hale"];
    },
    biura() {
      return this.$store.getters["search/biura"];
    }
  },
  methods: {
    haleToggle() {
      this.$store.dispatch("toggleList", { listType: "hale" });
    },
    biuraToggle() {
      this.$store.dispatch("toggleList", { listType: "biura" });
    },
    inwestorzyToggle() {
      this.$store.dispatch("toggleList", { listType: "inwestorzy" });
    },
    terenyGminy(gmina) {
      return this.$store.getters["search/terenyByGmina"][gmina.id] || [];
    },
    inwestorzyGminy(gmina) {
      return this.$store.getters["search/inwestorzyByGmina"][gmina.id] || [];
    },
    gminaShowTereny(gmina) {
      return this.terenyGminy(gmina).length > 0;
    },
    gminaShowInwestorzy(gmina) {
      return this.inwestorzyGminy(gmina).length > 0;
    }
  }
};
</script>
